import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
import type { SlideProps } from './SlideShell';
export function SlideLoveCover({}: SlideProps) {
  return <div className="relative flex h-full w-full items-center overflow-hidden bg-black px-[clamp(2rem,7vw,7rem)] text-white" data-id="element-323" data-mp="3kaxcetf8umat">
      <motion.div initial={{
      scaleX: 0
    }} animate={{
      scaleX: 1
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="absolute left-0 top-0 h-2 w-full origin-left bg-[var(--brand)]" data-id="element-324" data-mp="3p8qlbu7xlues" />
      <div className="pointer-events-none absolute -bottom-36 -right-24 h-[30rem] w-[30rem] rounded-full border-[54px] border-white/[0.04]" data-id="element-325" data-mp="3gaemj4wwvqb9" />
      <div className="pointer-events-none absolute bottom-20 right-36 h-24 w-24 rounded-full bg-[var(--brand)]/15" data-id="element-326" data-mp="36j0nszcsauj6" />

      <div className="relative max-w-6xl" data-id="element-327" data-mp="2sj95wnj5ctzw">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15,
        duration: 0.5
      }} className="mb-7 flex items-center gap-3 text-[var(--brand-lighter)]" data-id="element-328" data-mp="2sllwfp2z0cok">
          <HeartIcon className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-329" data-mp="1cco5a0y3whin" />
          <span className="text-xs font-bold uppercase tracking-[0.28em]" data-id="element-330" data-mp="1r95dijb01g0z">
            Attention is everything
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 28
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.28,
        duration: 0.75,
        ease: 'easeOut'
      }} className="text-[clamp(4rem,10vw,10rem)] font-extrabold leading-[0.88] tracking-[-0.065em] text-white" data-id="element-331" data-mp="1mbdobx1qo80h">
          All you need
          <br data-id="element-332" data-mp="18bm6tmc0k9hq" />
          is love.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.7,
        duration: 0.55
      }} className="mt-10 text-[clamp(1.35rem,2.6vw,2.5rem)] font-semibold tracking-[-0.02em] text-white/75" data-id="element-333" data-mp="13jb2m7a8q1jd">
          Attention makes things thrive.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.9,
        duration: 0.55
      }} className="mt-7 flex items-center gap-4" data-id="element-334" data-mp="10isskx0lk6ds">
          <span className="h-px w-12 bg-[var(--brand)]" data-id="element-335" data-mp="19dpaqf2aotds" />
          <p className="text-[clamp(0.95rem,1.5vw,1.3rem)] font-bold text-white" data-id="element-336" data-mp="1e94mn1gqsf7k">
            Do your brands get the love they deserve?
          </p>
        </motion.div>
      </div>
    </div>;
}